define('SageDotCom/Components/Content/DigitalNewsroom/DigitalNewsroomListing',[
    "jquery",
    "text!SageDotCom/Components/Templates/DigitalNewsroomCard.html",
    "eventManager"
], function ($, _cardTemplate, eventManager) {

    function DigitalNewsroomListing(scope, data, desktopCount, mobileCount) {
        Object.defineProperty(this, "scope", { enumerable: true, value: scope, writable: !1 });
        Object.defineProperty(this, "$scope", { enumerable: !0, value: $(scope) });
        
        const newsroomListings = $(scope).find(".digital-newsroom-listings");
        let container = newsroomListings.find(".digital-newsroom");
        const isMobile = container.hasClass("is-mobile");
        const numberToShow = isMobile ? mobileCount : desktopCount;

        let digitalNewsroomCardTemplate = _.template(_cardTemplate);
        let html = "";

        for (let i = 0; i < numberToShow && i < data.length; i++) {
            html += digitalNewsroomCardTemplate(data[i]);
        }
        container.html(html);

        eventManager.trigger("digital-newsroom-observe-videos");
        eventManager.trigger("digital-newsroom-find-dupes");

        //container.on("keydown", function (event) {
        //    //Workaround for keyboard nav
        //    debugger;
        //    if ((event.keyCode === 13) && $(event.target).hasClass("digital-newsroom-article")) {
        //        $(event.target).find(".digital-newsroom-article-link").click();
        //    }
        //});
    };

    DigitalNewsroomListing.init = function (args) {
        return new DigitalNewsroomListing(args.scope, args.data, args.desktopCount, args.mobileCount);
    };

    return DigitalNewsroomListing;

});
